import { useEffect, useState } from "react";
import { FileSrc } from "../../../AssetContext";
import UploadCardImage from "../../UploadCardImage";
import UploadFilesForm, { UploadTokenFilesForm } from "../../UploadFilesForm";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionCreators } from "../../../state";
import { OptimizedImage, SortedImages, sortImages } from "../../../functions/images";

export type UploadUtils = {
    tbr: any[], setTbr: any, tbu: any[], setTbu: any,
    coownTBR: any[], setCoownTBR: any, coownTBU: any[], setCoownTBU: any,
    prospTBR: any[], setProspTBR: any, prospTBU: any[], setProspTBU: any
}
export default function ExtraInfoFileUpload(props: {
    assetName: string, isSubmitted: boolean, coownership: FileSrc[], setCoownership: any,
    prospectus: FileSrc[], setProspectus: any,
    images2: FileSrc[], setImages2: any,
    documents: FileSrc[], setDocuments: any,
    uploadUtils: UploadUtils,
    media: any
}): JSX.Element {
    const { tbr, setTbr, tbu, setTbu, coownTBR, setCoownTBR, coownTBU, setCoownTBU, prospTBR, setProspTBR, prospTBU, setProspTBU } = props.uploadUtils
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    const [download, setDownload] = useState<boolean>(true)
    const [documentsSrc, setDocumentsSrc] = useState<{ url: string, filename: string }[]>([])
    const [sortedImages, setSortedImages] = useState<OptimizedImage[]>([])
    const [unsortedImages, setUnsortedImages] = useState<OptimizedImage[]>([])
    
    useEffect(() => {
        if (props.media && download) {
            actions.getDocuments(props.media, setDocumentsSrc)
            setDownload(false)
        }
    }, [props.media])

    useEffect(() => {
        if (props.media) {
            let imgs: SortedImages = sortImages(
                props.media.filter((m: any) => m.media_type_name === "Image"))
            actions.getAllImagesURL(imgs.sorted_images, setSortedImages)
            actions.getAllImagesURL(imgs.others.map((i) => {
                return { name: i, url_small: "", url_big: i, filename_big: "", filename_small: "" }
            }), setUnsortedImages)
        }
    }, [props.media])

    useEffect(() => {
        let i = [...sortedImages, ...unsortedImages].map((im) => {
            return {
                name: im.name, uploaded: true, src: im.url_big, small: im.url_small,
                filename_big: im.filename_big, filename_small: im.filename_small
            }
        })
        props.setImages2(i)
    }, [sortedImages, unsortedImages])

    useEffect(() => {
        let tmp: any = []
        documentsSrc.map((u) => {
            if (!u.filename.includes("coownership___") && !u.filename.includes("prospectus___"))
                tmp.push({ name: u.filename, uploaded: true, src: u.url })
        })
        props.setDocuments(tmp)

        let tmp2: any = []
        documentsSrc.map((u) => {
            if (u.filename && u.filename.includes("coownership"))
                tmp2.push({ name: u.filename, uploaded: true, src: u.url })
        })
        props.setCoownership(tmp2)

        let tmp3: any = []
        documentsSrc.map((u) => {
            if (u.filename && u.filename.includes("prospectus"))
                tmp3.push({ name: u.filename, uploaded: true, src: u.url })
        })
        props.setProspectus(tmp3)
    }, [documentsSrc])

    return <>
        <div className="col-span-12 grid mt-5">
            <UploadTokenFilesForm
                coownership={{
                    names: props.coownership, setNames: props.setCoownership,
                    tbr: coownTBR, tbu: coownTBU, setTbr: setCoownTBR, setTbu: setCoownTBU
                }}
                prospectus={{
                    names: props.prospectus, setNames: props.setProspectus,
                    tbr: prospTBR, tbu: prospTBU, setTbr: setProspTBR, setTbu: setProspTBU
                }}
                isSubmitted={props.isSubmitted} />
        </div>
        <div className="col-span-12 mt-5">
            <UploadCardImage images={props.images2} assetName={props.assetName} />
        </div>

        <div className="col-span-12 mt-5">
            <UploadFilesForm
                images={{
                    names: props.images2, setNames: props.setImages2,
                    tbr: tbr, tbu: tbu, setTbr: setTbr, setTbu: setTbu
                }}
                documents={{
                    names: props.documents, setNames: props.setDocuments,
                    tbr: tbr, tbu: tbu, setTbr: setTbr, setTbu: setTbu
                }}
                isSubmitted={props.isSubmitted} />
        </div>
    </>
}